import { render, staticRenderFns } from "./EmailEvents.vue?vue&type=template&id=4057d001&"
import script from "./EmailEvents.vue?vue&type=script&lang=js&"
export * from "./EmailEvents.vue?vue&type=script&lang=js&"
import style0 from "./EmailEvents.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports